export enum DomainStatus {
  DoesNotExist = 'DOES_NOT_EXIST',
  Unverifiable = 'UNVERIFIABLE',
  UnverifiableCustomSmtpHost = 'UNVERIFIABLE_CUSTOM_SMTP_HOST',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED',
  VerifiedIdeaRoomDomain = 'VERIFIED_IDEAROOM_DOMAIN',
}
